import { getOrderSeatRequirements } from './orderSeatRequirements';

export const INFANT_SEAT_PRICE = 2000;

export function getInfantSeatCount(order = {}) {
  const seat = getOrderSeatRequirements(order || {}).find(item => item.type === 'infant_seat');
  return seat ? (seat.quantity ?? '') : 0;
}

export function buildInfantSeatServices(value) {
  const quantity = Number(value);
  if (value === '' || !Number.isInteger(quantity) || quantity < 0 || quantity > 10) {
    throw new Error('请确认婴儿座椅数量（0至10个）');
  }
  return quantity ? [{ service_type: 'infant_seat', quantity, price: INFANT_SEAT_PRICE, description: 'ベビーシート', status: 'approved' }] : [];
}
